import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
/* eslint-disable react/prop-types */
import React from 'react';
import TabSelectorEntry from "./TabSelectorEntry";
import DetailBar from "./DetailBar";
import { _TabSelector } from "./styles";
var TabSelector = function TabSelector(_ref) {
  var currentTab = _ref.currentTab,
    detail = _ref.detail,
    selectedIndex = _ref.selectedIndex,
    set_tab = _ref.set_tab,
    tab_list = _ref.tab_list;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_TabSelector, null, tab_list.filter(function (entry) {
    return entry.label !== 'Preview Requirements';
  }).map(function (entry, idx) {
    return /*#__PURE__*/React.createElement(TabSelectorEntry, {
      icon: entry.icon,
      key: "tab-selector-".concat(idx),
      label: entry.label,
      onClick: set_tab,
      props: entry.props,
      selected: currentTab.toLowerCase() === entry.label.toLowerCase()
    });
  })), detail && /*#__PURE__*/React.createElement(DetailBar, {
    selectedIndex: selectedIndex,
    onNewRequirementsTab: selectedIndex === 0
  }, detail));
};
export default TabSelector;